module.exports = __webpack_public_path__ + "img/6-1.04d70f8d.png";